export default __webpack_public_path__ + "rocket.e73633dd.png";